export default class ModalIframeController {
  /* @ngInject */
  constructor(iframeLink, title, $sce) {
    this.iframeLink = iframeLink;
    this.title = title;
    this.link = $sce.trustAsResourceUrl(this.iframeLink);
  }

  onClose() {
    document.querySelector('.modal--iframe').remove();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal-iframe/modal.iframe.controller.js